/** GCP's credential-monitor fix generator: how to remediate a finding, as
 * opposed to `./index.ts`'s monitors, which describe what is risky. Stays in
 * `shared` (rather than `@p0security/integrations-gcloud-backend`) because `frontend`
 * reads `PresetMonitors[...].fix.generate` directly and shouldn't depend on
 * gcloud's backend-tier package. */
import type { ItemAssessmentScope } from "../../../../types/assessment.ts";
import type { CredentialNode } from "../../../../types/assessment/data/credential.ts";

export const credentialFixGenerator = (status: "disabled" | "enabled") => ({
  gcloud: {
    description: `${
      status === "disabled" ? "Re-enable" : "Disable"
    } these service-account keys by running these commands in Google Cloud Shell:`,
    type: "shell" as const,
    generate: (
      node: CredentialNode,
      { scope }: { scope: ItemAssessmentScope }
    ) => {
      // Note that credential key here is full key resource locator, not just key id
      const [account, _, key] = node.key.split("/").slice(6);
      return `gcloud iam service-accounts keys ${
        status === "disabled" ? "enable" : "disable"
      } \\
  '${key}' \\
  --iam-account='${account}' \\
  --project=${scope.id}`;
    },
  },
});
